<template>
  <PageWrapper
    v-if="canView"
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_SUBSCRIPTION_PLANS"
    title="Subscription Plans"
    :breadcrumbs="breadcrumbs"
    page-name="Subscription Plans"
    align="left"
    width="full"
  />
  <iText v-else>
    You don't have access to view this page.
  </iText>
</template>

<script>
import { mapState } from "pinia";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import PageWrapper from "@/components/PageWrapper.vue";
import {
  PAGE_PUBLICATION_SUBSCRIPTION_PLANS,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { useCollaboratorStore } from "@/stores/collaborator-store";

export default {
  name: "PublicationSubscriptionPlans",
  components: { PageWrapper },
  data() {
    return {
      PAGE_PUBLICATION_SUBSCRIPTION_PLANS,
      SECTION_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
      "publicationId",
      "publication",
    ]),
    ...mapState(useCollaboratorStore, [
      "canView",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        { url: `/publication/${this.publicationId}`, label: this.publication.name },
      ];
    },
  },
  mounted() {
    if (!this.canView) {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/publication/${this.publicationId}`;

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  },
};
</script>

<style scoped></style>
